import GlicPopoverCTA from './GlicPopoverCTA';

export default GlicPopoverCTA;
